import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SettingsPage } from './settings.page';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownModule } from '../../components/dropdown/dropdown.component.module';
import { PhraseBuilderModule } from '../../components/phrase-builder/phrase-builder.module';
import { SettingsGuardService } from '../../angular-wallet-base/services/settingsguard.service';
import { LodeUserFormComponentModule } from '../../components/lode-user-form/lode-user-form.component.module';
import { Enable2FAModalComponent } from '../../components/enable-2f-modal/enable-2fa-modal.component';
import { Enable2FAModalModule } from '../../components/enable-2f-modal/enable-2fa-modal.module';
import { KycModalComponent } from '../../components/kyc-modal/kyc-modal.component';
import { KycModalModule } from '../../components/kyc-modal/kyc-modal.module';
import { BackButtonModule } from '../../components/back-button/back-button.component.module';
import { TosContractsComponent } from 'src/app/components/tos-contracts/tos-contracts.component';
import { TosContractsModule } from 'src/app/components/tos-contracts/tos-contracts.module';
import { BankaccountComponentModule } from '../../components/bank-account-card/bankaccount.component.module';
import { PreferenceComponent } from './preference/preference.component';
import { SecurityComponent } from './security/security.component';
import { InvestmentContractsComponent } from './investment-contracts/investment-contracts.component';
import { SystemStatusComponent } from './system-status/system-status.component';
import { Enable2faComponent } from './enable2fa/enable2fa.component';
import { AgxTosComponent } from './agx-tos/agx-tos.component';
import { NgxKjuaModule } from 'ngx-kjua';
import { PinTextInputModule } from '../../components/pin-text-input/pin-text-input.module';
import { List2faDeviceComponent } from './list2fa-device/list2fa-device.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { BankAccountService } from 'src/app/angular-wallet-base/services/bank-account.service';
import { KycstatusModalModule } from 'src/app/components/kycstatus-modal/kycstatus-modal.module';
import { PrimaryAddressSuccessFailComponent } from './preference/primary-address-success-fail-modal/success-fail-modal';
import { ConfirmAddressComponent } from './preference/confirm-address-modal/confirm-address-modal';
import { SelectReceivingAddressComponent } from './preference/select-receiving-address/select-receiving-address.component';
import { SignatureRequestComponent } from './preference/signature-request/signature-request.component';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild([{ path: '', component: SettingsPage }]),
    TranslateModule,
    DropdownModule,
    Enable2FAModalModule,
    KycstatusModalModule,
    KycModalModule,
    LodeUserFormComponentModule,
    PhraseBuilderModule,
    BackButtonModule,
    TosContractsModule,
    BankaccountComponentModule,
    NgxKjuaModule,
    PinTextInputModule,
    NgxIntlTelInputModule
  ],
  declarations: [
    SettingsPage,
    PreferenceComponent,
    SecurityComponent,
    InvestmentContractsComponent,
    SystemStatusComponent,
    Enable2faComponent,
    AgxTosComponent,
    List2faDeviceComponent,
    PrimaryAddressSuccessFailComponent,
    ConfirmAddressComponent,
    SelectReceivingAddressComponent,
    SignatureRequestComponent
  ],
  providers: [],
  entryComponents: [Enable2FAModalComponent, KycModalComponent]
})
export class SettingsModule { }
